import { createContext, useContext, useReducer } from 'react';
import { OfficialDiaryPublicationState, OfficialDiaryPublicationReducer, ACTION_TYPES } from './official-diary-publication-reducer';
import moment from 'moment';
import { IPreviewPublicationRequest } from '../../../../model/sdp/official-daily/request/preview-publication-request';
import { IPreviewPublicationResponse } from '../../../../model/sdp/official-daily/response/preview-publication-response';
import ApplicationAppService from '../../../../application/platform/application-app-service';
import { useParams } from 'react-router-dom';

const OfficialDiaryPublicationContext = createContext<OfficialDiaryPublicationState | undefined>(undefined);
const OfficialDiaryPublicationDispatchContext = createContext({} as any);

const OfficialDiaryPublicationProvider = ({ children }: { children: React.ReactNode }) => {
    const applicationData = ApplicationAppService.getAuthenticationData();
    const { submissionPublicationId } = useParams();

    const initialState: OfficialDiaryPublicationState = {
        activeStep: 0,
        files: [],
        completed: {},
        previewPublicationRequest: {
            republication: false,
            submissionPublicationId: submissionPublicationId ? Number(submissionPublicationId) : undefined,
            clientId: applicationData?.type === 1 ? applicationData.company.id : undefined,
            publicationDateOn: moment().format("YYYY-MM-DD")
        } as IPreviewPublicationRequest,
        previewPublicationResponse: {} as IPreviewPublicationResponse,
        loading: false,
    };

    const [state, dispatch] = useReducer(OfficialDiaryPublicationReducer, initialState);

    return (
        <OfficialDiaryPublicationContext.Provider value={state}>
            <OfficialDiaryPublicationDispatchContext.Provider value={dispatch}>
                {children}
            </OfficialDiaryPublicationDispatchContext.Provider>
        </OfficialDiaryPublicationContext.Provider>
    );
}

const useOfficialDiaryPublicationState = () => {
    const context = useContext(OfficialDiaryPublicationContext);
    if (context === undefined) {
        throw new Error('useOfficialDiaryPublicationState must be used within a OfficialDiaryPublicationProvider');
    }
    return context;
}

const useOfficialDiaryPublicationDispatch = () => {
    const context = useContext(OfficialDiaryPublicationDispatchContext);
    if (context === undefined) {
        throw new Error('useOfficialDiaryPublicationDispatch must be used within a OfficialDiaryPublicationProvider');
    }
    return context;
}

export { OfficialDiaryPublicationProvider, useOfficialDiaryPublicationDispatch, useOfficialDiaryPublicationState, ACTION_TYPES };
